module.exports = __webpack_public_path__ + "img/NetworthUltd.0f44a92f.png";